import api from './service/api.service';

export const requestDemoMail = async (data: unknown) => {
  const targetUrl = 'v1/mail/request-demo';

  return await api.post(targetUrl, data);
};
